import { useRef } from "react";
import SelectBar from "../select";
import { useContextData } from "../../../map-page/data-context";
import "./index.scss";

interface IProps {
  isPC?: boolean;
  visible?: boolean;
  onCancel?: () => void;
  onConfirm?: () => void;
  selectOptions: any[];
}

const SelectModel = (props: IProps) => {
  const selectAddress = useRef();
  const { isPC, visible, onCancel, selectOptions } = props;
  const { setContextData } = useContextData();

  const confirm = () => {
    if (selectAddress.current) {
      setContextData({ selectAddress: selectAddress.current });
      onCancel?.();
    }
  }

  return visible ? <div className="select-modal-container">
    <div className="select-modal" style={{ width: isPC ? "31.25rem" : "80%" }}>
      <div className="title">请选择所在居委</div>
      <SelectBar
        className="select-bar"
        style={{ width: "90%" }}
        selectOptions={selectOptions}
        onSelect={(data) => {
          selectAddress.current = data;
        }} />
      <div className="buttons">
        <div className="button cancel" style={{ width: isPC ? "7.5rem" : "45%" }} onClick={onCancel}>取消</div>
        <div className="button confirm" style={{ width: isPC ? "7.5rem" : "45%" }} onClick={confirm}>确定</div>
      </div>
    </div>
  </div> : null;
}

export default SelectModel;